import { render, staticRenderFns } from "./ListGuest.vue?vue&type=template&id=11988258&"
import script from "./ListGuest.vue?vue&type=script&lang=js&"
export * from "./ListGuest.vue?vue&type=script&lang=js&"
import style0 from "./ListGuest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListGuestItem: require('/app/components/list/ListGuestItem.vue').default})
